import UserPropertyApi from "../../services/api/UserProperty";
import { getPath } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import _ from "lodash-es";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in feature actions:", err);
}

export const setUserPropertyList = (payload) => {
  return {
    type: ActionTypes.SET_USER_PROPERTY_LIST,
    payload,
  };
};

export const setActiveUserProperty = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_USER_PROPERTY,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS,
    payload,
  };
};

export const setCurrentPageUserProperty = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_USER_PROPERTY,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_USER_PROPERTY,
    payload,
  };
};

export const setUserPropertyKeys = (payload) => {
  return {
    type: ActionTypes.SET_USER_PROPERTY_KEYS,
    payload,
  };
};

export const getUserPropertyList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      console.log(filters, "filters--->");
      let userPropertyPayload = {
        ...filters,
        page: pageRequest.page || 1,
        page_size: 20,
      };
      dispatch(setLoader(true));
      console.log(pageRequest);
      console.log(userPropertyPayload);
      let response = await UserPropertyApi.getUserPropertyList(
        new URLSearchParams(userPropertyPayload).toString()
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setUserPropertyList(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getUserProperty = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await UserPropertyApi.getUserProperty(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveUserProperty(response.data.property));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createUserProperty = (data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await UserPropertyApi.createUserProperty(data);
    dispatch(setLoader(false));
    if (response) {
      if (response?.status?.code == 200) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
          })
        );
      } else {
        let err = response.status.message;
        dispatch(setLoader(false));
        dispatch(
          setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
          })
        );
        handleError(err);
      }
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateUserProperty = (data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await UserPropertyApi.updateUserProperty(data);
    dispatch(setLoader(false));
    if (response) {
      if (response?.status?.code == 200) {
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
          })
        );
      } else {
        let err = response.status.message;
        dispatch(setLoader(false));
        dispatch(
          setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
          })
        );
        handleError(err);
      }
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getUserPropertyKeys = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await UserPropertyApi.getUserPropertyKeys();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setUserPropertyKeys(response.data?.keys));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
